export const TIMEZONE = 'America/New_York';
export const LOCALE = 'us';
